@if (!iso && !rfc && !locale) {
<empty>-</empty>
} @if (iso) {
<time [attr.datetime]="iso">
  {{ iso | date : 'shortDate' : 'UTC' }}
</time>
} @if (locale) {
<time [attr.datetime]="locale">
  {{ locale | date : 'longDate' : 'UTC' }}
</time>
} @if (rfc) {
<time [attr.datetime]="rfc">
  {{ rfc }}
</time>
}
